<template>
    <!-- Новий дизайн: «Склади свою піцу», як у застосунку (Home.tsx) — звичайне вікно «В кошик» для товару-основи,
         добавки клієнт обирає сам. Кнопка — у ряду пошуку (Menu.vue), товар вантажить src/customPizza.js -->
    <AddToCart :preset="preset" @close="$emit('close')" @added="$emit('added')"/>
</template>

<script>
import AddToCart from '@/components/AddToCart.vue'

export default {
    name: 'BpCustomPizza',
    components: { AddToCart },
    props: {
        pizza: { type: Object, required: true }
    },
    data() {
        return {
            preset: { size: null, ingredients: [] },
            scrollY: 0
        }
    },
    // Так само, як картка піци (Product.vue): вікно читає товар зі сховища, після закриття повертаємось на місце
    created() {
        this.$store.commit('setCurrentProduct', JSON.parse(JSON.stringify(this.pizza)));
    },
    mounted() {
        this.scrollY = window.pageYOffset;
        window.scrollTo(0, 0);
        document.querySelector('body').style.overflow = 'hidden';
    },
    beforeDestroy() {
        document.querySelector('body').style.overflow = '';
        const y = this.scrollY;
        this.$nextTick(() => window.scrollTo(0, y));
    }
}
</script>
